import { PillarsBlend } from './components/PillarsBlend';
import './RandomPillars.scss';

export const RandomPillars = () => {
  return <PillarsBlend />;
};
